module.exports = __webpack_public_path__ + "static/media/mobile.81f09f26.svg";